import { URL_SERVICE, URL_BACK, URL_CONTACT } from '../constants/api-constants';
import { axiosInstance } from './axios-instance';
class HomeServices {
    // get pagoCuotaCredito info
    static getCreditFeePayment(payload, config) {
        return axiosInstance
            .post(`${URL_BACK}/certificadocredito/ws`, payload, config)
            .then((resp) => resp)
            .catch((e) => console.log(e));
    }

    // get educationPayment info
    static getEducationFeePayment(payload, config) {
        return axiosInstance
            .post(
                URL_SERVICE + '/edu/EDU-EDU-PagosPendientesEducacion',
                payload,
                config
            )
            .then((resp) => resp)
            .catch((e) => console.log(e));
    }

    // get business information
    static getBusinessInfo(payload, config) {
        return axiosInstance
            .post(
                URL_SERVICE + '/sub/SUB-AFIL-ConsultaServicioAportante',
                payload,
                config
            )
            .then((resp) => resp)
            .catch((e) => console.log(e));
    }

    // obtener certificado de afiliacion
    static getAfiliationCertificate(payload, config) {
        return axiosInstance
            .get(
                URL_BACK + '/afiliaciones/api/v1/consultaCertificado' + payload,
                config
            )
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // Enviar correo de certificados
    static sendCertificateEmail(payload, config) {
        return axiosInstance
            .put(URL_BACK + '/notificacion/api/v1/envioCorreo', payload, config)
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // consulta certificado de aportes
    static getContributionCertificateBusiness(payload, config) {
        return axiosInstance
            .get(
                URL_BACK +
                    '/aportes/api/v1/consultaCertificadoAporte' +
                    payload,
                config
            )
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // consulta historico de pagos
    static getPaymentHistoric(payload, config) {
        return axiosInstance
            .get(URL_BACK + '/placetopay/api/v1/historial' + payload, config)
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // consulta pdf de un item del historico
    static getPaymentHistoricPDF(payload, config) {
        return axiosInstance
            .get(URL_BACK + '/placetopay/api/v1/comprobante' + payload, config)
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // Crea la sesion para el portal de pagos
    static createSessionPlaceToPay(payload, config) {
        return axiosInstance
            .post(URL_BACK + '/placetopay/api/v1/crearSesion', payload, config)
            .then((resp) => resp.data)
            .catch((e) => e);
    }

    // revisa el estado del pago
    static checkPaymentPlaceToPay(payload) {
        return axiosInstance
            .get(URL_BACK + '/placetopay/api/v1/detalle' + payload)
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // actualiza el estado de un pago a cancelado
    static cancelPaymentPlaceToPay(payload, config) {
        return axiosInstance
            .put(URL_BACK + '/placetopay/api/v1/cancelar' + payload, config)
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // send a trazability item to DB
    static sendTraceItem(payload, config) {
        return axiosInstance
            .post(
                URL_BACK + '/registrointereacciones/api/v1/interacciones',
                payload,
                config
            )
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // send a request
    static sendARequest(payload) {
        return axiosInstance
            .post(URL_CONTACT + 'createTicketContact', payload)
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // get historical tickets
    static getHistoricalTickets(documentNumber, documentType) {
        return axiosInstance
            .get(
                URL_CONTACT +
                    `getTicketProcedureRecords?documentNumber=${documentNumber}&documentType=${documentType}`
            )
            .then((resp) => resp.data)
            .catch((e) => console.log(e));
    }

    // Get JWT Algorithm
    static getTokenRecomendationURL(payload, config) {
        return axiosInstance.post(
            process.env.ALGORITMO_CARRUSEL_TOKEN_URL,
            payload,
            config
        );
    }

    // Get Algorithm recommendations
    static getRecomendationURL(config) {
        return axiosInstance.get(
            process.env.ALGORITMO_CARRUSEL_RECOMENDACION_URL,
            config
        );
    }
}
export default HomeServices;
